
import { computed, defineComponent, PropType } from 'vue'
import { useStore } from '@/store'
import { ElementTypes, PPTElement, Slide } from '@/types/slides'
// 修改
import BaseAudioElement from '@/views/componentsaudience/element/AudioElement/BaseAudioElement.vue'
import BaseVideoElement from '@/views/componentsaudience/element/VideoElement/BaseVideoElement.vue'
import BaseImageElement from '@/views/componentsaudience/element/ImageElement/BaseImageElement.vue'
import BaseTextElement from '@/views/componentsaudience/element/TextElement/BaseTextElement.vue'
import BaseShapeElement from '@/views/componentsaudience/element/ShapeElement/BaseShapeElement.vue'
import BaseLineElement from '@/views/componentsaudience/element/LineElement/BaseLineElement.vue'
import ScreenChartElement from '@/views/componentsaudience/element/ChartElement/ScreenChartElement.vue'
import BaseTableElement from '@/views/componentsaudience/element/TableElement/BaseTableElement.vue'

export default defineComponent({
  name: 'screen-element',
  props: {
    elementInfo: {
      type: Object as PropType<PPTElement>,
      required: true,
    },
    elementIndex: {
      type: Number,
      required: true,
    },
    animationIndex: {
      type: Number,
      default: -1,
    },
  },
  setup(props) {
    const currentElementComponent = computed(() => {
      const elementTypeMap = {
        [ElementTypes.AUDIO]: BaseAudioElement,
        [ElementTypes.VIDEO]: BaseVideoElement,
        [ElementTypes.IMAGE]: BaseImageElement,
        [ElementTypes.TEXT]: BaseTextElement,
        [ElementTypes.SHAPE]: BaseShapeElement,
        [ElementTypes.LINE]: BaseLineElement,
        [ElementTypes.CHART]: ScreenChartElement,
        [ElementTypes.TABLE]: BaseTableElement,
      }
      return elementTypeMap[props.elementInfo.type] || null
    })

    const store = useStore()
    const theme = computed(() => store.state.theme)
    const currentSlide = computed<Slide>(() => store.getters.currentSlide)

    // 判断元素是否需要等待执行入场动画：等待执行的元素需要先隐藏
    const needWaitAnimation = computed(() => {
      const animations = currentSlide.value.animations || []
      const elementIndexInAnimation = animations.findIndex(animation => animation.elId === props.elementInfo.id)
      if (elementIndexInAnimation !== -1 && elementIndexInAnimation >= props.animationIndex) return true
      return false      
    })

    return {
      currentElementComponent,
      needWaitAnimation,
      theme,
    }
  },
})
